"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PartnerSupportTicketWaitingOn = void 0;
/** Which side a partner support ticket is currently waiting on. */
var PartnerSupportTicketWaitingOn;
(function (PartnerSupportTicketWaitingOn) {
    PartnerSupportTicketWaitingOn["AVEN"] = "AVEN";
    PartnerSupportTicketWaitingOn["PARTNER"] = "PARTNER";
})(PartnerSupportTicketWaitingOn || (exports.PartnerSupportTicketWaitingOn = PartnerSupportTicketWaitingOn = {}));
